import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'ZmEzZGM3MzU4OWEzNmI2NmZlNDBmOWNiYTI1NjEwNWI=',
  'Tenant-Access-Key': '7MpG7nsE0Ln6yg',
};
 
export const BASE_URL = "https://immersive-game-india.confirmu.com";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});